const STAGGER = 110;

export default function reveal(items: HTMLElement[], onReveal?: (item: HTMLElement) => void): void {
	if (!items.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		items.forEach((item) => {
			item.classList.add('is-revealed');
			onReveal?.(item);
		});

		return;
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const item = entry.target as HTMLElement;
				const index = items.indexOf(item);

				item.style.setProperty('--stagger-delay', `${Math.max(index, 0) * STAGGER}ms`);
				item.classList.add('is-revealed');
				onReveal?.(item);

				obs.unobserve(item);
			});
		},
		{ threshold: 0.3 }
	);

	items.forEach((item) => observer.observe(item));
}

export function initReveal(): void {
	document.querySelectorAll<HTMLElement>('.armada-media-text').forEach((block) => {
		reveal([block]);
	});

	document.querySelectorAll<HTMLElement>('.armada-question-grid').forEach((block) => {
		reveal([block]);
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-question-grid__item')));
	});

	document.querySelectorAll<HTMLElement>('.armada-feature-cards').forEach((block) => {
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-feature-cards__card')));

		const footer = block.querySelector<HTMLElement>('.armada-feature-cards__footer');

		if (footer) {
			reveal([footer]);
		}
	});

	document.querySelectorAll<HTMLElement>('.armada-gallery').forEach((block) => {
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-gallery__item')));
	});

	document.querySelectorAll<HTMLElement>('.armada-process').forEach((block) => {
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-process__step')));
	});

	document.querySelectorAll<HTMLElement>('.armada-videos').forEach((block) => {
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-videos__item')));
	});

	document.querySelectorAll<HTMLElement>('.armada-testimonials').forEach((block) => {
		reveal([block]);
	});

	document.querySelectorAll<HTMLElement>('.armada-faq').forEach((block) => {
		reveal(Array.from(block.querySelectorAll<HTMLElement>('.armada-faq__item')));
	});

	document.querySelectorAll<HTMLElement>('.armada-cta').forEach((block) => {
		reveal([block]);
	});
}
